import { useState, createContext } from "react";

export const DataContext = createContext({
  data: [],
  dataCat200: [],
  dataCat300: [],
  dataCat400: [],
  dataCat500: [],
  openedCat: null,
  clickedPointData: {},
  clickedPointDataOld: {},
  SetData: () => {},
  SetDataCat200: () => {},
  SetDataCat300: () => {},
  SetDataCat400: () => {},
  SetDataCat500: () => {},
  SetOpenedCat: () => {},
  SetClickedPointData: () => {},
  SetClickedPointDataOld: () => {},
});

const DataContextProvider = (props) => {
  const [data, setData] = useState({});
  const [dataCat200, setDataCat200] = useState([]);
  const [dataCat300, setDataCat300] = useState({});
  const [dataCat400, setDataCat400] = useState({});
  const [dataCat500, setDataCat500] = useState({});
  const [openedCat, setOpenedCat] = useState();
  const [clickedPointData, setClickedPointData] = useState();
  const [clickedPointDataOld, setClickedPointDataOld] = useState();

  const SetData = (state) => {
    setData(state);
  };
  const SetDataCat200 = (data) => {
    setDataCat200(data);
  };
  const SetDataCat300 = (data) => {
    setDataCat300(data);
  };
  const SetDataCat400 = (data) => {
    setDataCat400(data);
  };
  const SetDataCat500 = (data) => {
    setDataCat500(data);
  };
  const SetOpenedCat = (data) => {
    setOpenedCat(data);
  };

  const SetClickedPointData = (data) => {
    setClickedPointData(data);
  };
  const SetClickedPointDataOld = (data) => {
    setClickedPointDataOld(data);
  };

  return (
    <DataContext.Provider
      value={{
        data,
        dataCat200,
        dataCat300,
        dataCat400,
        dataCat500,
        openedCat,
        clickedPointData,
        clickedPointDataOld,
        SetData,
        SetDataCat200,
        SetDataCat300,
        SetDataCat400,
        SetDataCat500,
        SetOpenedCat,
        SetClickedPointData,
        SetClickedPointDataOld,
      }}
    >
      {props.children}
    </DataContext.Provider>
  );
};

export default DataContextProvider;
